import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "label", "input"]

  connect() {
    this.closeHandler = this.close.bind(this)
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    if (!this.menuTarget.classList.contains("hidden")) {
      setTimeout(() => document.addEventListener("click", this.closeHandler))
    } else {
      document.removeEventListener("click", this.closeHandler)
    }
  }

  select(event) {
    event.preventDefault()
    if (this.hasInputTarget) this.inputTarget.value = event.currentTarget.dataset.value
    if (this.hasLabelTarget) this.labelTarget.textContent = event.currentTarget.dataset.label
    this.close()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.closeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
  }
}
